import { CompanyUserAttributes, CompanyUserRole } from '@/types'
import { UpdateCompanyUserMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditCompanyUserQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { ErrorMessage, Field, Label } from '../base/fieldset'
import { Selector as RoleSelector } from './role/selector'

type CompanyUser = EditCompanyUserQuery['companyUsers']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
    fieldErrors,
    attributes,
    setAttributes
  } = useForm<UpdateCompanyUserMutation, CompanyUserAttributes, EditCompanyUserQuery, CompanyUser>({
    id,
    initializer: companyUser => ({
      role: companyUser.role,
      email: companyUser.user.email,
    }),
    query: EditQuery,
    queryKey: 'companyUsers',
    mutation: UpdateMutation,
    resultKey: 'updateCompanyUser'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Email', field: 'email', type: 'email', disabled: true }) }
        <Field>
          <Label>Role</Label>
          <RoleSelector
            invalid={!!fieldErrors?.role}
            value={attributes.role}
            onChange={value => setAttributes({ ...attributes, role: value?.id as CompanyUserRole || CompanyUserRole.Crew }) }
          />
          { fieldErrors?.role && <ErrorMessage>{ fieldErrors?.role }</ErrorMessage> }
        </Field>
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
